import { render, staticRenderFns } from "./SMSTextBoxEditor.vue?vue&type=template&id=0c3c9e00&"
import script from "./SMSTextBoxEditor.vue?vue&type=script&lang=js&"
export * from "./SMSTextBoxEditor.vue?vue&type=script&lang=js&"
import style0 from "./SMSTextBoxEditor.vue?vue&type=style&index=0&id=0c3c9e00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports